import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { RouterModule } from '@angular/router';
import { AccountService } from '../../core-module/services/account.service';
import { filterManagementFeatures } from './management-feature.utils';

@Component({
  selector: 'app-managements',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './managements.component.html',
  styleUrls: ['./managements.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManagementsComponent {
  private accountService = inject(AccountService);
  private currentUser = toSignal(this.accountService.currentUser$, { initialValue: null });
  private userRoles = computed(() => this.currentUser()?.roles?.map((r: any) => r.name) ?? []);
  private userPermissions = computed(() => this.currentUser()?.permissions ?? []);

  features = computed(() => {
    return filterManagementFeatures(
      this.userRoles(),
      this.userPermissions()
    );
  });
}
